import fetch ,{postFrom} from "../utils/fetch";


export function posList(params) {
  return fetch({
    method: 'GET',
    url: 'posSetting/posList',
    params
  })
}

export function addPos(params) {
  return fetch({
    method: 'POST',
    url: 'posSetting/addPos',
    data:params
  })
}
export function toEditPos(params) {
  return fetch({
    method: 'GET',
    url: 'posSetting/toEditPos',
    params
  })
}

export function updatePos(params) {
  return fetch({
    method: 'POST',
    url: 'posSetting/updatePos',
    data:params
  })
}
export function deletePos(params) {
  return fetch({
    method: 'POST',
    url: 'posSetting/deletePos',
    params
  })
}
